import moment from "moment";
import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../components/Header";
import parse from "html-react-parser";

export default function DetailNotifications() {
  const { state } = useLocation();

  return (
    <div className="overflow-hidden">
      <Header title="Detail Notification" />
      <div className="relative space-y-10 overflow-y-auto">
        <div className="-mx-2 pt-16 pb-4 px-6">
          <div className="flex items-center justify-between ">
            <div className="text-xl font-bold text-gray-900 uppercase pt-1.5 pb-2">
              {state.title ?? ""}
            </div>
          </div>
          <div className="text-sm text-gray-400 mb-8">
            {moment(state.created_at).format("DD-MM-YYYY") ?? "-"}
          </div>
          <p className="text-gray-600">{parse(state.content ?? "")}</p>
        </div>
      </div>
    </div>
  );
}
